import { lazy, Suspense } from 'react';
import Hero from '../components/Hero';
import Marquee from '../components/Marquee';
import Integrations from '../components/Integrations';
import Industries from '../components/Industries';
import WhyUs from '../components/WhyUs';
import Blog from '../components/Blog';
import Contact from '../components/Contact';

// The 3D carousel pulls in three.js + postprocessing (~1 MB). Loading it as a
// separate chunk lets the rest of the page render first, and keeps it off
// other routes entirely.
const ServiceCarousel3D = lazy(() => import('../components/ServiceCarousel3D'));

export default function Home() {
  return (
    <>
      <Hero />
      <Marquee />
      {/* Placeholder matches the carousel's footprint so the page doesn't
          jump and "/#services" links still have a target while it loads. */}
      <Suspense fallback={<div id="services" style={{ height: '100vh' }} />}>
        <ServiceCarousel3D />
      </Suspense>
      <Integrations />
      <Industries />
      <WhyUs />
      <Blog />
      {/* Testimonials ("What our clients say") hidden for now — re-add <Testimonials /> here when ready */}
      <Contact />
    </>
  );
}
